import { Box, styled } from '@mui/material';

const Panel = styled(Box)`
  display: flex;
`;

export default Panel;
